/**
 * useLeaflet — Sprint 4.1.
 *
 * Carrega Leaflet 1.9 via CDN unpkg. Não acrescenta dependência npm
 * (evita rebuild de node_modules em ambientes constrained).
 *
 * Idempotente: múltiplas chamadas reaproveitam window.L.
 * Retorna { L, ready, error } — L é null até `ready === true`.
 */
import { useEffect, useState } from "react";

const LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
const LEAFLET_JS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
const LEAFLET_CSS_SRI =
  "sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H";
const LEAFLET_JS_SRI =
  "sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH";

function injectCss(href) {
  if (document.querySelector(`link[href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.integrity = LEAFLET_CSS_SRI;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

function injectScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-leaflet="1"]`);
    if (existing) {
      if (window.L) return resolve(window.L);
      existing.addEventListener("load", () => resolve(window.L));
      existing.addEventListener("error", reject);
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.dataset.leaflet = "1";
    s.integrity = LEAFLET_JS_SRI;
    s.crossOrigin = "anonymous";
    s.onload = () => resolve(window.L);
    s.onerror = () => reject(new Error("Falha ao carregar Leaflet"));
    document.head.appendChild(s);
  });
}

export function useLeaflet() {
  const [L, setL] = useState(window.L || null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (window.L) {
      setL(window.L);
      return;
    }
    injectCss(LEAFLET_CSS);
    injectScript(LEAFLET_JS)
      .then((Lref) => {
        if (!cancelled) setL(Lref);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { L, ready: !!L, error };
}
